import React from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import ManagerLogin from './components/ManagerLogin';

import MasterReportForm from './components/master/MasterReportForm';

import FactoriesPage from './components/references/FactoriesPage';
import MastersPage from './components/references/MastersPage';

import DailyReportsPage from './components/daily/DailyReportsPage';

import MonthlyReportsPage from './components/monthly/MonthlyReportsPage';

import ManagerMenu from './components/ManagerMenu'; // Подключаем главное меню
import AnalyticsPage from './components/analytics/AnalyticsPage';  // Импортируем страницу Аналитика
import SickLeavePage from './components/monthly/SickLeavePage'; // Импортируем страницу "Больничные"
import FinancePage from './components/finance/FinancePage'; // Импортируем страницу "Финансы"
import ChangelogPage from './components/changelog/ChangelogPage'; // Импортируем страницу "Журнал изменений"


function App() {
    const location = useLocation(); // Получаем текущий путь
    const isMasterRoute = location.pathname.startsWith('/master'); // Проверяем, начинается ли путь с /master
    const isAuthRoute = location.pathname === '/' || location.pathname === '/manager/login'; // Проверяем, это страница авторизации

    return (
            <div>
                {!isMasterRoute && !isAuthRoute && <ManagerMenu />} {/* Меню будет скрыто для маршрутов /master/... и страниц авторизации */}
                <Routes>
                    <Route path="/" element={<ManagerLogin />} />
                    <Route path="/manager/factories" element={<FactoriesPage />} />
                    <Route path="/manager/masters" element={<MastersPage />} />
                    <Route path="/manager/daily-reports" element={<DailyReportsPage />} />
                    <Route path="/manager/monthly-reports" element={<MonthlyReportsPage />} />
                    <Route path="/master/:uniqueLink" element={<MasterReportForm />} />
                    <Route path="/manager/login" element={<ManagerLogin />} />
                    <Route path="/manager/sick-leave" element={<SickLeavePage />} />
                    <Route path="/manager/analytics" element={<AnalyticsPage />} />
                    <Route path="/manager/finance" element={<FinancePage />} />
                    <Route path="/manager/changelog" element={<ChangelogPage />} />
                </Routes>
            </div>
    );
}

function AppWrapper() {
    return (
        <Router>
            <App />
        </Router>
    );
}

export default AppWrapper;
